import React, { ReactElement } from 'react'
import styled from 'styled-components'

const Styles = styled.div`
  position: relative;
  font-size: 13px;
  margin-top: 1px;
`
interface IRemainingProps {
  showRemaining?: boolean
  quantity?: number | null
  quantitySold?: number
  soldOut?: boolean
}
function Remaining(props: IRemainingProps): ReactElement | null {
  const {
    showRemaining, quantity, quantitySold, soldOut,
  } = props

  return quantity
    && (quantitySold || quantitySold === 0)
    && showRemaining
    && !soldOut ? (
      <Styles>{`${quantity - quantitySold} remaining`}</Styles>
    ) : null
}
export default Remaining
